<template>
    <v-dialog v-model="addContactDig" persistent max-width="420px">
        <v-card>
            <v-card-text>
                <p class="headline text-center mb-0">Add Contact</p>
                <small text-center>Select how to import your contact</small>
                <v-row>
                    <v-layout class="pa-3">
                        <v-flex xs12 sm6 md6 text-center mt-2>
                            <v-icon class="mr-2 display-4 pa-0" style="margin-right: 0!important">
                                mdi-email-outline
                            </v-icon>
                            <p>Add a Contact</p>
                        </v-flex>
                        <v-flex xs12 sm6 md6 text-center mt-2>
                            <v-icon class="mr-2 display-4 pa-0 mr-0" style="margin-right: 0!important">
                                mdi-file-document-box-outline
                            </v-icon>
                            <p>.CSV</p>
                        </v-flex>
                    </v-layout>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        icon: {type: Boolean, default: false},
        btnSaveText: {type: String, default: 'Save'},
        btnCloseText: {type: String, default: 'Close'},
        onAction: {type: String, default: 'add'},
        headline: {type: String, default: ''},
        pretext: {type: String, default: ''},
        listName: {type: String, default: ''},
        loading: {type: Boolean, default: false},
        addContactDig: {type: Boolean, default: false},
        closemodal: {type: Function, default: () => {
            this.addContactDig = false
        }},
        okcallback: {type: Function, default: () => {
            this.addContactDig = false
        }},
    },
    methods: {
        async savemodal(event) {
            try {
                await this.okcallback(this.listName)
            } catch {
                throw new Error('function callback.')
            }
        },
    },
}
</script>